export const MonthlyEmail = {
    name: 'monthly_email',
    label: 'Monthly Email',
    subject: "Exciting New Destinations, Features, and Financial News on Rebit! 🌏",
    category: 'offers',
    body: "<p>Hi ${first_name},</p>"
        + "<p>We're thrilled to bring you the latest updates and features on Rebit, making it easier than ever to connect with loved ones and manage your transactions worldwide!</p>"
        + "<p style='text-align: center'><img src='https://rebitmoney.com/blog/wp-content/uploads/2024/10/email-november-e1730288343834.png' alt='Oman Australia Indonesia Rebit Transfer' width='240px'></p>"
        + "<p>🌍 <b>New Destinations and Currencies</b></p>"
        + "<p>Rebit is expanding to new countries and currencies. Now, you can send or convert your money to:</p>"
        + "<ul>"
        + "<li>🇴🇲 Oman - Available Now!</li>"
        + "<li>🇮🇩 Indonesia - Available Now!</li>"
        + "<li>🇦🇺 Australia - Launching Soon!</li>"
        + "<li>🇺🇸 Tether - Active in most locations</li>"
        + "</ul>"
        + "<p>With these new routes, you'll enjoy faster, more flexible, and accessible transfers, keeping you connected wherever you need.</p>"
        + "<p>&nbsp;</p>"
        + "<p>🚀 <b>New Features to Enhance Your Experience</b></p>"
        + "<p>We've recently rolled out features to make your Rebit experience even smoother:</p>"
        + "<ul>"
        + "<li><b>Tracking Enhancement -</b> Easily download or request receipts for all transactions. View banking references. More readable date/time format</li>"
        + "<li><b>Profile Address Updates - </b>Updating your location, contact and address is now quick and simple.</li>"
        + "<li><b><em>Coming up next month: Rebit app in Farsi</em></b></li>"
        + "</ul>"
        + "<p>&nbsp;</p>"
        + "<p>📲 <b>Follow Us for the Latest Financial News</b></p>"
        + "<p>Stay informed with regular updates and insights tailored to New Zealand and Australia. Follow us on Instagram and Telegram to receive the latest financial news and be the first to know about new Rebit features as they launch.</p>"
        + "<ul>"
        + "<li><a href='https://www.instagram.com/rebit.money?igsh=MWdnbXM4MGVtZThjeQ=='><b>@rebit.money Instagram</b></a></li>"
        + "<li><a href='https://t.me/rebit_money'><b>@rebit_money Telegram</b></a></li>"
        + "<li><b>New page on Blog: </b><a href='https://rebitmoney.com/blog/guide/'><b>Step-by-Step Guide: How to Rebit</b></a></li>"
        + "</ul>"
        + "<p>Thank you for being part of the Rebit family! We're excited to keep innovating and providing you with the best money transfer experience possible.</p>"
        + "<p>&nbsp;</p>"
        + "<p>Warm Regards,<br>The Rebit Team 🌐</p>"
}

